<div class="row mb-4">
    <div class="col-md-12 d-flex justify-content-end">
        <button type="button" class="help-btn" (click)="onHelp(true)" aria-label="Ayuda" title="Ayuda">
            <i class="fa fa-info"></i>
        </button>
    </div>
</div>

<div class="row">
    <div class="col-sm-12">
        <app-file-list [documentData]="loteDetalleUrls" (fileSelected)="selectDocument($event)"></app-file-list>

        <div *ngIf="documentIsLoading">
            <div class="document-loading-box">
                <i class="fa fa-spinner fa-pulse"></i>
                <p>Cargando ...</p>
            </div>
        </div>
    </div>
    <div class="col-sm-12" *ngIf="!documentIsLoading">
        <app-file-viewer data-tour="area-seleccion-firmas" [url_document]="documentPdfUrl" [certificado]="certificado"
            [listCertificado]="listCertificados" (addCertificado)="addCertificado($event)"
            (deleteCertificado)="deleteCoordenada($event)" [firma_esgrupo]="es_grupo" [read_only]="readonly"
            [usa_plantilla]="usa_plantilla" [modulo]="'simple'"></app-file-viewer>
    </div>
</div>
